import { Typography, styled } from "@mui/material";
import { editorName } from "../classes.js";
const Placeholder = styled(Typography, {
  name: editorName,
  slot: "Placeholder",
  overridesResolver: (_, styles) => styles.placeholder
})(({ theme }) => ({
  top: theme.spacing(1),
  left: theme.spacing(1),
  color: (theme.vars ?? theme).palette.text.disabled,
  padding: theme.spacing(1),
  overflow: "hidden",
  position: "absolute",
  userSelect: "none",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis",
  pointerEvents: "none"
}));
export {
  Placeholder
};
//# sourceMappingURL=Placeholder.js.map
